import React from 'react';
import PropTypes from 'prop-types';

import appleBadge from '@/assets/download/Download_on_the_App_Store_Badge_US-UK_RGB_wht_092917.svg';
import googlePlayBadge from '@/assets/download/GetItOnGooglePlay_Badge_Web_color_English.svg';

import './StoreBadges.css';

// Where the app is listed in each store. Kept here so every page that shows
// the badges links to the same place.
export const APP_STORE_URL =
    'https://apps.apple.com/us/app/msu-denver-roadrunner-connect/id6633438909';
export const GOOGLE_PLAY_URL =
    'https://play.google.com/store/apps/details?id=edu.msudenver.roadrunnerconnect';

/**
 * The App Store and Google Play badges, side by side, each linking to the
 * app's store page in a new tab.
 *
 * Each badge image sits directly inside its link. A link is already
 * clickable and reachable with the keyboard, so a button inside it would
 * only give screen readers two controls for one action.
 */
const StoreBadges = ({ className = '' }) => (
    <div
        className={`store-badges d-flex justify-content-center align-items-end ${className}`.trim()}
    >
        <a
            className="store-badge-link"
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
        >
            <img
                src={appleBadge}
                alt="Download on the App Store"
                className="app-store-badge"
            />
        </a>
        <a
            className="store-badge-link"
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
        >
            <img
                src={googlePlayBadge}
                alt="Get it on Google Play"
                className="google-play-badge"
            />
        </a>
    </div>
);

StoreBadges.propTypes = {
    // Extra classes for spacing on the page that uses it, e.g. "mt-4".
    className: PropTypes.string,
};

export default StoreBadges;
